import React from "react";

const PatientContext = React.createContext();
PatientContext.displayName = "PatientContext";

export default PatientContext;
